import { Map } from 'immutable';
import { utils } from '@saucelabs/sl-module-performance';

import * as constants from '../types';

const initialState = new Map({
  isMetricsHistoryAvailable: false,
  loadingMetricsHistoryDetail: false,
  metricsHistoryDetail: new Map(),
  testsCount: 0,
});

const metricHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.GET_METRICS_HISTORY.REQUEST: {
      return state.withMutations((newState) => {
        newState
          .set('metricsHistoryDetail', new Map())
          .set('loadingMetricsHistoryDetail', true)
          .set('isMetricsHistoryAvailable', false)
          .set('testsCount', 0);
      });
    }
    case constants.GET_METRICS_HISTORY.SUCCESS: {
      return state.withMutations((newState) => {
        newState
          .set('metricsHistoryDetail', new Map(payload))
          .set('testsCount', utils.findTestsCount(payload))
          .set('loadingMetricsHistoryDetail', false)
          .set('isMetricsHistoryAvailable', Object.keys(payload).some((key) => payload[key].length > 1));
      });
    }
    case constants.GET_METRICS_HISTORY.FAILURE:
      return state.set('loadingMetricsHistoryDetail', false);
    case constants.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default metricHistoryReducer;
export { initialState };
